const webServicesData = [
  {
    title: "Website Design & Development",
    description:
      "We don't just build websites; we create user experiences that engage and convert. Our designers and developers collaborate to bring your vision to life with a stunning, functional website.",
    bullets: ["Custom Design", "Responsive Layout", "SEO Friendly", "User-Centric"],
    minHeight: 400,
  },
  {
    title: "CMS Development",
    description:
      "Empower yourself to easily update and manage your website content with a user-friendly CMS. We'll choose the perfect platform based on your needs, whether it's WordPress, Drupal, or a custom solution.",
    bullets: ["Multi-User Support", "Integrated SEO tools", "Analytics Integration", "Flexibility and scalability"],
    minHeight: 400,
  },
  {
    title: "API Development & Integration",
    description:
      "Connect your web application to external data sources and services with our expert API development and integration. This allows for a more powerful and dynamic user experience.",
    bullets: ["Custom API Solutions", "Third-Party Integration", "Secure and Reliable", "Real-Time Data Access"],
    minHeight: 400,
  },
  {
    title: "Web 3.0 Development",
    description:
      "Be at the forefront of the next generation of the web with our Web 3.0 development expertise. Build applications that prioritise user data ownership, enhanced privacy, and a more open and connected web.",
    bullets: ["NFT Development", "Smart Contracts", "Data Privacy", "Interoperability"],
    minHeight: 400,
  },
  {
    title: "AI/ML Web Solutions",
    description:
      "Integrate cutting-edge Artificial Intelligence and Machine Learning into your web app to automate tasks, personalise user experiences, and gain valuable insights from your data.",
    bullets: ["Natural Language Processing", "Image and Video Analysis", "AI-driven security", "Predictive Analytics"],
    minHeight: 400,
  },
  {
    title: "Bespoke Web Development",
    description:
      "Have a unique vision for your web project? We can build it from the ground up. Our team can handle everything from custom web development to legacy system migration and front-end functionality improvements.",
    bullets: ["Requirement Analysis", "Tailored Solutions", "Agile Methodology", "Post-Launch support"],
    minHeight: 400,
  },
  {
    title: "Headless Development",
    description:
      "Craft exceptional user experiences with the freedom and flexibility of headless development. Our headless development services empower you to build dynamic and future-proof web applications.",
    bullets: ["Rapid Development", "API-Driven", "Enhanced Security", "Seamless Integration"],
    minHeight: 400,
  },
  {
    title: "Upgrade & Migration",
    description:
      "Need to upgrade your existing website or migrate to a new platform? We handle the entire process smoothly and efficiently, minimising downtime and disruption.",
    bullets: ["Data Integrity Assurance", "Platform Migration", "Identify and mitigate risks", "Performance Optimization"],
    minHeight: 400,
  },
  {
    title: "Maintenance & Support",
    description:
      "We don't just build it; we maintain it. Our ongoing support ensures your web application continues to run smoothly and securely and delivers optimal performance. We'll handle bug fixes, updates, security patches, and server monitoring.",
    bullets: ["Proactive Maintenance", "Backup and Recovery", "Bug Fixes and Updates", "Continuous optimisation"],
    minHeight: 400,
  },
];


export const Tabs = [
  {
    key: "seo",
    icon: "fa-solid fa-magnifying-glass",
    label: "SEO Optimisation",
    title: "SEO Optimisation",
    desc:
      "We ensure that your website is optimised for search engines right from the start. We optimise meta tags, headers, content, and images to improve search engine visibility and enhance website speed and mobile responsiveness for better search rankings.",
    bullets: [
      "Keyword Research",
      "Technical SEO",
      "On‑Page SEO",
      "Page Speed Optimisation",
    ],
  },
  {
    key: "security",
    icon: "fa-regular fa-image",
    label: "Security",
    title: "Security",
    desc:
      "Protecting your website and user data is our top priority. We implement SSL certificates to encrypt data transmitted between your website and users, ensuring privacy and security. Our team conducts regular security audits to identify and fix vulnerabilities.",
    bullets: [
      "SSL Certificates",
      "Firewalls & DDoS Protection",
      "Secure Coding Practices",
      "Regular Security Audits",
    ],
  },
  {
    key: "ecom",
    icon: "fa-solid fa-store",
    label: "E‑Commerce Integration",
    title: "E‑Commerce Integration",
    desc:
      "We specialise in creating robust e‑commerce platforms that drive sales and enhance user experience. We design user‑friendly shopping experiences with intuitive product pages, shopping carts, and checkout processes.",
    bullets: [
      "Secure Payment Gateways",
      "User‑Friendly Shopping Experience",
      "Inventory Management",
      "Analytics and Reporting",
    ],
  },
  {
    key: "cro",
    icon: "fa-regular fa-rectangle-list",
    label: "Conversion Rate Optimisation",
    title: "Conversion Rate Optimisation",
    desc:
      "At our core, we are dedicated to maximising your website's conversion rates through meticulous analysis and proven testing methodologies.",
    bullets: [
      "A/B Testing",
      "Conversion Funnel Analysis",
      "UX Design",
      "Performance Metrics Tracking",
    ],
  },
];

export default webServicesData;
